import React from 'react'

const ImpressumEN = () => {
    return (
        <>
            <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: 'ol{margin:0;padding:0}table td,table th{padding:0}.c6{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Albert Sans";font-style:normal}.c14{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:26pt;font-family:"Albert Sans";font-style:normal}.c0{background-color:#ffffff;padding-top:10pt;padding-bottom:10pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c1{color:#222323;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Albert Sans";font-style:normal}.c11{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Albert Sans";font-style:normal}.c19{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c12{color:#222323;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Albert Sans";font-style:normal}.c2{background-color:#ffffff;padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c4{background-color:#ffffff;padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c18{padding-top:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left}.c8{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c7{background-color:#ffffff;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline;text-decoration-skip-ink:none;font-size:12pt}.c17{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c15{text-decoration-skip-ink:none;font-size:12pt;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline}.c5{background-color:#ffffff;font-size:12pt;color:#0a0a0a}.c16{background-color:#ffffff;max-width:451.4pt;padding:72pt 72pt 72pt 72pt}.c3{color:inherit;text-decoration:inherit}.c13{color:#222323;font-size:12pt}.c9{background-color:#ffff00}.c10{height:11pt}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Albert Sans"}p{margin:0;color:#000000;font-size:11pt;font-family:"Albert Sans"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}'
                }}
            />
            <p className="c8">
                <span className="c11">Imprint</span>
            </p>
            <p className="c8">
                <span className="c11">As of April 2024</span>
            </p>
            <p className="c4">
                <span className="c1">Wemolo GmbH</span>
            </p>
            <p className="c4">
                <span className="c1">St.-Martin-Strasse 72</span>
            </p>
            <p className="c4">
                <span className="c1">81541 Munich</span>
            </p>
            <p className="c4">
                <span className="c1">Germany</span>
            </p>
            <p className="c4 c10">
                <span className="c1" />
            </p>
            <p className="c2">
                <span className="c7">
                    <a className="c3" href="mailto:help@wemolo.com">
                        help@wemolo.com
                    </a>
                </span>
                <span className="c5">&nbsp;</span>
            </p>
            <p className="c2">
                <span className="c1">Tel.: +49 89 6931 464 91</span>
            </p>
            <p className="c2">
                <span className="c13">Website: </span>
                <span className="c15">
                    <a className="c3" href="https://www.wemolo.com">
                        www.wemolo.com
                    </a>
                </span>
                <span className="c1">&nbsp;</span>
            </p>
            <p className="c0">
                <span className="c1">
                    Represented by the managing directors: Jakob Bodenmüller, Yukio Iwamoto, Bastian Pieper
                </span>
            </p>
            <p className="c2">
                <span className="c1">Headquarters: Munich</span>
            </p>
            <p className="c2">
                <span className="c1">Register Court: Munich Local Court</span>
            </p>
            <p className="c2">
                <span className="c1">Registration number: HRB 250653</span>
            </p>
            <p className="c2">
                <span className="c1">Sales tax identification number: DE325788012</span>
            </p>
            <p className="c0">
                <span className="c1">
                    Note: This imprint applies to all websites operated by Wemolo, in particular the above-mentioned
                    website as well as the blog and help center of Wemolo and the web-based software.
                </span>
            </p>
            <p className="c0">
                <span className="c12">Liability for contents</span>
            </p>
            <p className="c0">
                <span className="c1">
                    The contents of our pages were created with the utmost care. However, we cannot guarantee the
                    accuracy, completeness and timeliness of the content. As a service provider, we are responsible for
                    our own content on these pages. However, we are not obligated as a service provider to monitor
                    transmitted or stored third-party information or to investigate circumstances that indicate illegal
                    activity. Obligations to remove or block the use of information under the general laws remain
                    unaffected. However, liability in this regard is only possible from the point in time at which a
                    concrete infringement of the law becomes known. If we become aware of any such infringements, we
                    will remove this content immediately.
                </span>
            </p>
            <p className="c0">
                <span className="c12">Copyright</span>
            </p>
            <p className="c0">
                <span className="c1">
                    The contents of this website are subject to copyright, unless otherwise indicated, and may not be
                    distributed, modified or copied in whole or in part without the prior written consent of Wemolo. The
                    images included on this website may not be used without the prior written consent of Wemolo. Some of
                    the images contained on the website are subject to the copyright of third parties. Insofar as the
                    content on this site was not created by the operator, the copyrights of third parties are respected.
                    In particular, third-party content is identified as such. Should you nevertheless become aware of a
                    copyright infringement, please inform us accordingly. If we become aware of any infringements, we
                    will remove such content immediately.
                </span>
            </p>
            <p className="c0">
                <span className="c12">Liability for links</span>
            </p>
            <p className="c0">
                <span className="c1">
                    Our offer contains links to external websites of third parties, on whose contents we have no
                    influence. Therefore, we cannot assume any liability for these external contents. The respective
                    provider or operator of the pages is always responsible for the content of the linked pages. The
                    linked pages were checked for possible legal violations at the time of linking. Illegal contents
                    were not recognizable at the time of linking. However, a permanent control of the contents of the
                    linked pages is not reasonable without concrete evidence of a violation of the law. If we become
                    aware of any infringements, we will remove such links immediately.
                </span>
            </p>
            <p className="c0">
                <span className="c12">Responsible</span>
            </p>
            <p className="c2">
                <span className="c1">Jakob Bodenmüller (Managing Director)</span>
            </p>
            <p className="c2">
                <span className="c1">St. Martin Street 72</span>
            </p>
            <p className="c2">
                <span className="c1">81541 Munich, Germany</span>
            </p>
            <p className="c2">
                <span className="c1">Tel.: +49 (0) 89 356477 60</span>
            </p>
            <p className="c2">
                <span className="c13">Email: </span>
                <span className="c7">
                    <a className="c3" href="mailto:help@wemolo.com">
                        help@wemolo.com
                    </a>
                </span>
                <span className="c5">&nbsp;</span>
            </p>
            <p className="c0">
                <span className="c12">Competent supervisory authority for data protection complaints</span>
            </p>
            <p className="c2">
                <span className="c1">Bavarian State Office for Data Protection Supervision</span>
            </p>
            <p className="c2">
                <span className="c1">PO Box 1349</span>
            </p>
            <p className="c2">
                <span className="c1">91504 Ansbach, Germany</span>
            </p>
            <p className="c0 c10">
                <span className="c11" />
            </p>
            <p className="c10 c18">
                <span className="c11" />
            </p>
            <p className="c10 c17">
                <span className="c6" />
            </p>
        </>
    )
}

export default ImpressumEN
